// Senaïa's Cosmetics — Theme JavaScript

(function() {
  'use strict';

  var notificationTimer = null;

  function showCartNotification(title, text) {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;

    var titleEl = notification.querySelector('.cart-notification__title');
    var textEl = notification.querySelector('.cart-notification__text');

    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text || '';

    notification.classList.add('is-visible');

    clearTimeout(notificationTimer);
    notificationTimer = setTimeout(function() {
      notification.classList.remove('is-visible');
    }, 4000);
  }

  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.cart-notification__close');
    if (closeBtn) {
      var notification = document.getElementById('cart-notification');
      if (notification) notification.classList.remove('is-visible');
    }
  });

  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.js-cart-count');
    countEls.forEach(function(el) {
      el.textContent = count !== undefined ? count : el.textContent;
    });
  }

  function fetchCartCount() {
    fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
    })
    .catch(function() {});
  }

  function addToCart(variantId, quantity, productTitle, btn) {
    if (!variantId) return;
    if (btn) {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.textContent = '...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      fetchCartCount();
      showCartNotification(
        item.product_title || productTitle || 'Added to cart',
        item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''
      );
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || btn.textContent;
      }
    })
    .catch(function() {
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || btn.textContent;
      }
    });
  }

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.js-product-form');
    if (!form) return;
    e.preventDefault();

    var variantInput = form.querySelector('.js-variant-id');
    var qtyInput = form.querySelector('.js-qty-input');
    var submitBtn = form.querySelector('[type="submit"]');
    var productTitle = document.querySelector('.product-page__title');

    var variantId = variantInput ? variantInput.value : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var title = productTitle ? productTitle.textContent.trim() : '';

    addToCart(variantId, qty, title, submitBtn);
  });

  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('.js-add-to-cart');
    if (!addBtn) return;
    e.preventDefault();

    var variantId = addBtn.dataset.variantId;
    var productTitle = addBtn.dataset.productTitle;

    addToCart(variantId, 1, productTitle, addBtn);
  });

  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '{{amount}} EUR';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function updateCartQuantity(lineIndex, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      if (window.refreshCartPage) window.refreshCartPage(cart);
    })
    .catch(function() {});
  }

  document.addEventListener('click', function(e) {
    var qtyMinus = e.target.closest('.js-qty-minus');
    var qtyPlus = e.target.closest('.js-qty-plus');

    if (qtyMinus || qtyPlus) {
      var wrapper = (qtyMinus || qtyPlus).closest('.js-qty-wrapper');
      if (!wrapper) return;

      var input = wrapper.querySelector('.js-qty-input');
      if (!input) return;

      var currentVal = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 9999;

      if (qtyMinus && currentVal > min) {
        input.value = currentVal - 1;
      } else if (qtyPlus && currentVal < max) {
        input.value = currentVal + 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.js-cart-remove');
    if (!removeBtn) return;
    e.preventDefault();

    var lineIndex = parseInt(removeBtn.dataset.line, 10);
    if (lineIndex) {
      updateCartQuantity(lineIndex, 0);
      var row = removeBtn.closest('.cart-item, tr');
      if (row) {
        row.style.opacity = '0.5';
        row.style.pointerEvents = 'none';
      }
      setTimeout(function() { location.reload(); }, 600);
    }
  });

  function initVariantSelector() {
    var selectors = document.querySelectorAll('.js-variant-selector');
    selectors.forEach(function(select) {
      select.addEventListener('change', function() {
        var variantId = this.value;
        var variantIdInput = document.querySelector('.js-variant-id');
        if (variantIdInput) variantIdInput.value = variantId;

        var option = this.options[this.selectedIndex];
        var price = option.dataset.price;
        var comparePrice = option.dataset.comparePrice;
        var available = option.dataset.available === 'true';

        var priceEl = document.querySelector('.js-product-price');
        var comparePriceEl = document.querySelector('.js-product-compare-price');
        var addBtn = document.querySelector('.js-product-submit');

        if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price, 10));
        if (comparePriceEl) {
          if (comparePrice && parseInt(comparePrice, 10) > parseInt(price, 10)) {
            comparePriceEl.textContent = formatMoney(parseInt(comparePrice, 10));
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !available;
          if (!available) {
            addBtn.textContent = window.theme && window.theme.strings ? window.theme.strings.soldOut : 'Sold Out';
          } else {
            addBtn.textContent = window.theme && window.theme.strings ? window.theme.strings.addToCart : 'Add to Cart';
          }
        }
      });
    });
  }

  function initCollectionFiltering() {
    var sortSelect = document.querySelector('.js-collection-sort');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    fetchCartCount();

    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

    initVariantSelector();
    initCollectionFiltering();

    var settings = window.theme && window.theme.settings ? window.theme.settings : {};

    if (settings.enableAnimations !== false && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

      document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
        observer.observe(el);
      });
    }

    if ('loading' in HTMLImageElement.prototype === false) {
      document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
        img.src = img.src;
      });
    }
  });

})();
